import Vue from 'vue'
import Router from 'vue-router'
import project from './views/project'
// import favouriteBoy from "./views/favouriteBoy/favouriteBoy"
import store from "@/store";
import {getPermissions} from "@/api/auth";


// 解决vue报错vue-router.esm.js
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

// 路由详情
let routes = [
  {
    path: '/',
    redirect: '/home',
    meta: {requiresAuth: false, hidden: true, hide_menu: false}
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['@/views/login'], resolve),
    // requiresAuth 是否需要登陆
    meta: {requiresAuth: false, hidden: true, hide_menu: true}
  },
  // 钉钉绑定
  {
    path: '/bindDingDing',
    name: 'bindDingDing',
    component: resolve => require(['@/views/bindDingDing'], resolve),
    meta: {requiresAuth: false, hidden: true, hide_menu: true}
  },
  // 飞书绑定
  {
    path: '/bindFeishu',
    name: 'bindFeishu',
    component: resolve => require(['@/views/bindFeishu'], resolve),
    meta: {requiresAuth: false, hidden: true, hide_menu: true}
  },
  // 钉钉信息同步并注册
  {
    path: '/dingtalk/:unionid/register',
    name: 'dingtalk-register',
    component: resolve => require(['@/views/dingtalk/register'], resolve),
    meta: {requiresAuth: false, hidden: true, hide_menu: true}
  },
  // 首页
  {
    path: '/home',
    name: 'home',
    component: () => import('./views/dashboard/home.vue'),
    meta: {
      requiresAuth: true,
      hidden: false,
      hide_menu: false,
      title: '首页',
      icon: 'el-icon-s-home',
      icon_active: 'el-icon-s-home',
      auth: 'home'
    },
  },
  {
    path: '/files/preview',
    name: 'FilesPreview',
    component: () => import('./components/FilePreview/files.vue'),
    meta: {hidden: true, title: '文件预览',}
  },
  {
    path: '/workbench',
    name: 'workbench',
    component: project,
    meta: {requiresAuth: true, hidden: true, title: '工作台', auth: 'workbench'},
    children: [
      {
        path: '/workbench/someoneOrders',
        name: 'SomeoneOrders',
        component: () => import('./views/workbench/SomeoneOrders/index.vue'),
        meta: {hidden: false, title: '与我相关',}
      },
      {
        path: '/workbench/contract',
        name: 'WorkbenchContract',
        component: () => import('./views/workbench/Contract/index.vue'),
        meta: {hidden: true, title: '合同工作台',}
      },
    ]
  },
  {
    path: '/notify',
    name: 'notify',
    component: () => import(/* webpackChunkName: "home" */ './views/notify/index.vue'),
    meta: {
      requiresAuth: true,
      hidden: false,
      title: '消息通知',
      icon: 'el-icon-message-solid',
      icon_active: 'el-icon-message-solid',
      auth: 'notify'
    }
  },
  // 仪表盘
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('./views/dashboard/index.vue'),
    meta: {
      requiresAuth: true,
      hidden: false,
      title: '仪表盘(新)',
      icon: 'el-icon-home',
      icon_active: 'el-icon-home-active',
      auth: 'dashboard_new'
    },
  },

  // 仪表盘路由
  {
    path: '/homeOld',
    name: 'homeOld',
    component: () => import('./views/Home'),
    meta: {
      requiresAuth: true,
      hidden: false,
      title: '仪表盘',
      icon: 'el-icon-home',
      icon_active: 'el-icon-home-active',
      auth: 'dashboard'
    },
  },
  {
    path: '/home/brandDetail',
    name: 'homeBrandDetail',
    component: () => import('./views/dashboard/brandDetail.vue'),
    meta: {requiresAuth: true, title: '品牌详情', hidden: true, keepAlive: false, auth: 'normal'}
  },
  {
    path: '/home/artistDetail',
    name: 'homeArtistDetail',
    component: () => import('./views/dashboard/artistDetail.vue'),
    meta: {requiresAuth: true, title: '红人详情', hidden: true, keepAlive: false, auth: 'normal'}
  },
  {
    path: '/home/platformDetail',
    name: 'homePlatformDetail',
    component: () => import('./views/dashboard/platformDetail.vue'),
    meta: {requiresAuth: true, title: '平台详情', hidden: true, keepAlive: false, auth: 'normal'}
  },
  {
    path: '/home/customerDetail',
    name: 'homeCustomerDetail',
    component: () => import('./views/dashboard/customerDetail.vue'),
    meta: {requiresAuth: true, title: '客户详情', hidden: true, keepAlive: false, auth: 'normal'}
  },
  {
    path: '/home/ScopeCustomerDetail',
    name: 'scopeCustomerDetail',
    component: () => import('./views/dashboard/ScopeCustomerDetail.vue'),
    meta: {requiresAuth: true, title: '我的重点客户详情', hidden: true, keepAlive: false, auth: 'key_customer_sale'}
  },
  {
    path: '/home/saleDetail',
    name: 'homeSaleDetail',
    component: () => import('./views/dashboard/saleDetail.vue'),
    meta: {requiresAuth: true, title: '销售详情', hidden: true, keepAlive: false, auth: 'normal'}
  },
  {
    path: '/home/orderDetail',
    name: 'dashboardOrderDetail',
    component: () => import('@/views/dashboard/orderDetail.vue'),
    meta: {requiresAuth: true, title: '订单详情', hidden: true, keepAlive: false, auth: 'normal'}
  },
  {
    path: '/home/orderDetailNCustomer',
    name: 'dashboardOrderDetailNCustomer',
    component: () => import('@/views/dashboard/orderDetailNCustomer.vue'),
    meta: {requiresAuth: true, title: '销售新客详情', hidden: true, keepAlive: false, auth: 'normal'}
  },

  {
    path: '/project/',
    meta: {
      requiresAuth: true,
      hidden: false,
      title: '基础资料',
      icon: 'el-icon-cominfo',
      icon_active: 'el-icon-cominfo',
      auth: 'basic_data'
    },
    component: project,
    children: [
      // {
      //     path: '/project/favouriteBoy',
      //     name: 'favouriteBoy',
      //     component: favouriteBoy,
      //     meta: {
      //         requiresAuth: true,
      //         hidden: false,
      //         title: '红人资料',
      //         icon: '',
      //         keepAlive: true,
      //         auth: 'manage_menu_artist_info'
      //     }
      // },
      {
        path: '/project/favouriteBoyNew',
        name: 'favouriteBoyNew',
        component: () => import('@/views/favouriteBoy/index.vue'),
        meta: {
          requiresAuth: true,
          hidden: false,
          title: '红人资料',
          icon: '',
          keepAlive: true,
          auth: 'manage_menu_artist_info'
        }
      },
      {
        path: '/project/customer',
        name: 'custom',
        component: () => import('@/views/custom/index.vue'),
        meta: {
          requiresAuth: true,
          hidden: false,
          title: '客户资料',
          icon: '',
          auth: 'manage_basic_customer_info',
          keepAlive: true,
        }
      },
      {
        path: '/project/myCustom',
        name: 'myCustom',
        component: () => import('@/views/custom/sellerCustomer.vue'),
        meta: {
          requiresAuth: true,
          hidden: false,
          title: '我的客户',
          icon: '',
          auth: 'manage_menu_customer_info',
          keepAlive: true,
        }
      },
      {
        path: '/project/optionSet',
        name: 'optionSet',
        component: () => import('./views/optionSetting/optionSet.vue'),
        meta: {requiresAuth: true, hidden: false, title: '选项配置', icon: '', auth: 'can_option_settings'}
      },
      {
        path: '/project/addFBoy',
        name: 'addFBoy',
        component: () => import('./views/favouriteBoy/addFBoy.vue'),
        meta: {requiresAuth: true, title: '添加红人', hidden: true, keepAlive: false, auth: 'normal'}
      },
      {
        path: '/project/addCustom',
        name: 'addCustom',
        component: () => import('./views/custom/addCustom.vue'),
        meta: {requiresAuth: true, title: '添加客户', hidden: true, keepAlive: false, auth: 'normal'} //hidden:true不显示在导航栏 keepAlive:true缓存
      },
      {
        path: '/project/:id/addCustom',
        name: 'editCustom',
        component: () => import('./views/custom/addCustom.vue'),
        meta: {requiresAuth: true, title: '编辑客户', hidden: true, keepAlive: false, auth: 'normal'} //hidden:true不显示在导航栏 keepAlive:true缓存
      },
      {
        path: '/project/detailCustom',
        name: 'detailCustom',
        component: () => import('./views/custom/detailCustom.vue'),
        meta: {requiresAuth: true, title: '客户详情', hidden: true, keepAlive: false, auth: 'normal'} //hidden:true不显示在导航栏 keepAlive:true缓存
      },
      {
        path: '/project/brand',
        name: 'brand',
        component: () => import('@/views/brand/index.vue'),
        meta: {requiresAuth: true, hidden: false, title: '品牌资料', icon: '', auth: 'manage_basic_brand',}
      },
      {
        path: '/project/combine_customer',
        name: 'combineCustomer',
        component: () => import('@/views/combine/customer/index.vue'),
        meta: {requiresAuth: true, hidden: true, title: '客户集团', icon: '', auth: 'manage_basic_combine',}
      },
      {
        path: '/project/combine_brand',
        name: 'combineBrand',
        component: () => import('@/views/combine/brand/index.vue'),
        meta: {requiresAuth: true, hidden: true, title: '品牌集团', icon: '', auth: 'manage_basic_combine',}
      },
      {
        path: '/project/yearFrameAuditor',
        name: 'yearFrameAuditor',
        component: () => import('@/views/custom/components/yearFrame/index.vue'),
        meta: {requiresAuth: true, title: '客户年框审核', auth: 'manage_year_frame_audit'}
      },
      {
        path: '/project/yearFrameProposer',
        name: 'yearFrameProposer',
        component: () => import('@/views/custom/components/yearFrame/index.vue'),
        meta: {requiresAuth: true, title: '客户年框申请', auth: 'manage_year_frame_audit'}
      },
      {
        path: '/project/yearFrameAck',
        name: 'yearFrameAck',
        component: () => import('@/views/custom/components/yearFrame/ack-list.vue'),
        meta: {requiresAuth: true, title: '年框列表', auth: 'year_frame_ack_list'}
      },
      {
        path: '/project/yearFrameSchedule',
        name: 'yearFrameSchedule',
        component: () => import('@/views/custom/components/yearFrame/schedule-list.vue'),
        meta: {requiresAuth: true, title: '年框进度', auth: 'year_frame_schedule_list'}
      },
      {
        path: '/customer/level',
        name: 'customerLevel',
        component: () => import('@/views/customerLevel/index.vue'),
        meta: {requiresAuth: true, title: '客户等级配置', auth: 'manage_year_frame_audit'}
      },
      {
        path: '/customer/key_customer',
        name: 'keyCustomer',
        component: () => import('@/views/custom/components/customer/index.vue'),
        meta: {requiresAuth: true, title: '重点客户', auth: 'key_customer'}
      },
      {
        path: '/customer/key_customer_sale',
        name: 'keyCustomer',
        component: () => import('@/views/custom/components/customer/sale/index.vue'),
        meta: {requiresAuth: true, title: '重点客户（我）', auth: 'key_customer_sale'}
      },
      {
        path: '/brand/search',
        name: 'brandSearch',
        component: () => import('./views/brandSearch/searchResult'),
        meta: {requiresAuth: true, title: '品牌检索', auth: 'brand_search_list'}
      },
      {
        path: '/brand/record',
        name: 'BrandRecord',
        component: () => import('./views/brand/record/BrandRecord'),
        meta: {requiresAuth: true, title: '品牌展示', auth: 'manage_brand_record'}
      },
      {
        path: '/volume/search',
        name: 'volumeSearch',
        component: () => import('./views/customerSaleVolume/index'),
        meta: {requiresAuth: true, title: '新客检测', auth: 'customer_detection_list'}
      },
      {
        path: '/customer/pool',
        name: 'customerPool',
        component: () => import('./views/customerPool/pool.vue'),
        meta: {requiresAuth: true, title: '公海客户池', auth: 'customer_pool_list'}
      },
      {
        path: '/customer/pool_task',
        name: 'customerPoolTask',
        component: () => import('./views/customerPool/CustomerPoolTask'),
        meta: {requiresAuth: true, title: '客户跟进', auth: 'customer_pool_task_list'}
      },
      {
        path: '/order/discount',
        name: 'orderDiscount',
        component: () => import('./views/discount/index'),
        meta: {requiresAuth: true, title: '折扣设置', auth: 'view_rebate_config'}
      },
      {
        path: '/order/company',
        name: 'orderCompany',
        component: () => import('./views/company/index'),
        meta: {requiresAuth: true, title: '乙方配置', auth: 'can_pt_company_settings'}
      }
    ]
  },
  {
    path: '/ad_menu',
    name: "ad-menu",
    component: project,
    meta: {
      title: '订单管理',
      hidden: true,
      icon: 'el-icon-gg',
      icon_active: 'el-icon-gg-active',
      auth: 'manage_m_adv_order'
    },
    children: [
      {
        path: '/ad',
        name: 'ad-order',
        meta: {
          title: '广告订单',
          hidden: false,
          icon: 'el-icon-gg',
          icon_active: 'el-icon-gg-active',
          auth: 'manage_menu_adv_order'
        },
        component: () => import('./views/adOrder/Index.vue'),
      },
      {
        path: '/ad_wcm',
        name: 'ad-wcm',
        meta: {
          title: '全案营销',
          hidden: false,
          icon: 'el-icon-gg',
          icon_active: 'el-icon-gg-active',
          auth: 'view_the_wcm_order'
        },
        component: () => import('./views/adOrder/project/Index.vue'),
      },
      {
        path: '/ad_regulars',
        name: 'ad_regulars',
        meta: {
          title: '普客打包',
          hidden: false,
          icon: 'el-icon-gg',
          icon_active: 'el-icon-gg-active',
          auth: 'view_the_puke_order'
        },
        component: () => import('./views/adOrder/regular/Index.vue'),
      },
      {
        path: '/ad_wcm',
        name: 'ad-wcm',
        meta: {
          title: '全案营销',
          hidden: false,
          icon: 'el-icon-gg',
          icon_active: 'el-icon-gg-active',
          auth: 'view_the_wcm_order'
        },
        component: () => import('./views/adOrder/project/Index.vue'),
      },
      {
        path: '/ad_wcm_live',
        name: 'ad_wcm_live',
        meta: {
          title: '直播数据汇总',
          hidden: false,
          icon: 'el-icon-gg',
          icon_active: 'el-icon-gg-active',
          auth: 'report_live_summary'
        },
        component: () => import('./views/adOrder/project_live/Index.vue'),
      },
      {
        path: '/customer_activation',
        name: 'customer-activation',
        meta: {
          title: '老客激活统计',
          hidden: false,
          auth: 'view_customer_activation'
        },
        component: () => import('./views/customerActivation/index.vue'),
      },
      {
        path: '/order/live-guarantee-list',
        name: 'OrderLiveGuaranteeList',
        component: () => import('./views/adOrder/live-guarantee/list-pool.vue'),
        meta: {requiresAuth: true, title: '直播数据池', auth: 'live_guarantee__list_pool'}
      },
      {
        path: '/order/live-guarantee-list-claim',
        name: 'OrderLiveGuaranteeListClaim',
        component: () => import('./views/adOrder/live-guarantee/list-claim.vue'),
        meta: {requiresAuth: true, title: '直播保量数据认领', auth: 'live_guarantee__list_claim'}
      },
      {
        path: '/order/live-guarantee-stat',
        name: 'OrderLiveGuaranteeStat',
        component: () => import('./views/adOrder/live-guarantee/stat.vue'),
        meta: {requiresAuth: true, title: '直播保量数据汇总', auth: 'live_guarantee__list_stat'}
      },
      {
        path: '/income_summary',
        name: 'IncomeSummaryIndex',
        component: () => import('./views/adOrder/income_summary/index.vue'),
        meta: {requiresAuth: true, title: '收入汇总', auth: 'income_summary'}
      },
      {
        path: '/income_summary/agent_confirm',
        name: 'IncomeSummaryConfirm',
        component: () => import('./views/adOrder/income_summary/agent_confirm/index.vue'),
        meta: {requiresAuth: true, title: '订单确认', auth: 'income_summary'}
      },
      {
        path: '/income_summary/assistant_confirm',
        name: 'IncomeSummaryAssistantConfirm',
        component: () => import('./views/adOrder/income_summary/assistant_confirm/index.vue'),
        meta: {requiresAuth: true, title: '订单确认(助理)', auth: 'income_summary'}
      },
      {
        path: '/income_summary/:order_id/:order_no/agent_detail',
        name: 'detailAgentOrder',
        component: () => import('./views/adOrder/income_summary/detail/Index.vue'),
        meta: {requiresAuth: true, title: '订单详情', auth: 'income_summary'}
      },
      {
        path: '/order/live-guarantee-list-commission',
        name: 'OrderLiveGuaranteeListCommission',
        component: () => import('./views/adOrder/live-guarantee/list-commission.vue'),
        meta: {requiresAuth: true, title: '直播佣金认领', auth: 'live_guarantee__list_commission'}
      },
      {
        path: '/sale_target/setting',
        name: 'SaleTargetSetting',
        component: () => import('./views/adOrder/sale_target/index.vue'),
        meta: {requiresAuth: true, title: '销售目标设定', auth: 'sale_target_setting'}
      },
      // {
      //   path: '/order/ensure_income',
      //   name: 'EnsureIncomeIndex',
      //   component: () => import('./views/adOrder/income_summary/ensure_income/index.vue'),
      //   meta: {requiresAuth: true, title: 'XX收入', auth: 'ensure_income__list'}
      // }
    ]
  },
  {
    path: '/ad/create',
    name: 'createAdOrder',
    component: () => import('./views/adOrder/order/Create.vue'),
    meta: {title: '添加广告订单', hidden: true, keepAlive: false, auth: 'normal'} //hidden:true不显示在导航栏 keepAlive:true缓存
  },
  {
    path: '/ad/:id/edit',
    name: 'editAdOrder',
    component: () => import('./views/adOrder/order/Edit.vue'),
    meta: {title: '修改广告订单', hidden: true, keepAlive: false, auth: 'normal'} //hidden:true不显示在导航栏 keepAlive:true缓存
  },
  {
    path: '/adWcm/create',
    name: 'createAdOrderWcm',
    component: () => import('./views/adOrder/project/Create.vue'),
    meta: {title: '添加全案营销', hidden: true, keepAlive: false, auth: 'normal'} //hidden:true不显示在导航栏 keepAlive:true缓存
  },
  {
    path: '/adWcm/:id/edit',
    name: 'editAdOrderWcm',
    component: () => import('./views/adOrder/project/Edit.vue'),
    meta: {title: '修改全案营销', hidden: true, keepAlive: false, auth: 'normal'}
  },
  {
    path: '/ad/account',
    name: 'ad-account',
    component: () => import('./views/account/Index'),
    meta: {title: '回款记录', hidden: true, keepAlive: false, auth: 'normal'} //hidden:true不显示在导航栏 keepAlive:true缓存
  },
  {
    path: '/ad/contract',
    name: 'ad-contract',
    component: () => import('./views/contract/ContractIndex'),
    meta: {title: '合同信息', hidden: true, keepAlive: false, auth: 'normal'} //hidden:true不显示在导航栏 keepAlive:true缓存
  },
  //普客打包
  {
    path: '/adRegulars/create',
    name: 'createAdOrderRegulars',
    component: () => import('./views/adOrder/regular/Create.vue'),
    meta: {title: '添加普客打包订单', hidden: true, keepAlive: false, auth: 'normal'} //hidden:true不显示在导航栏 keepAlive:true缓存
  },
  {
    path: '/adRegulars/:id/edit',
    name: 'editAdOrderRegulars',
    component: () => import('./views/adOrder/regular/Edit.vue'),
    meta: {title: '修改普客打包', hidden: true, keepAlive: false, auth: 'normal'}
  },
  //回款管理
  {
    path: '/payRecord',
    component: project,
    meta: {
      title: '回款管理',
      hidden: false,
      keepAlive: false,
      icon: 'iconfont icon-pay_record-copy',
      icon_active: 'iconfont iconfont icon-pay_record-copy',
      auth: 'manage_menu_pay_record'
    },//hidden:true不显示在导航栏 keepAlive:true缓存
    children: [
      {
        path: '/payRecord/index',
        name: 'payRecord-index',
        component: () => import('./views/payRecord/index.vue'),
        meta: {title: '回款记录', hidden: false, keepAlive: false, auth: 'page_pay_record'},
      },
      {
        path: '/payRecord/tick',
        name: 'payRecord-tick',
        component: () => import('./views/payRecord/tick/index.vue'),
        meta: {title: '回款认领', hidden: false, keepAlive: false, auth: 'page_tick_pay_record'},
      },
      {
        path: '/payRecord/exception',
        name: 'payRecord-exception',
        component: () => import('./views/payRecord/exception/index.vue'),
        meta: {title: '异常回款', hidden: false, keepAlive: false, auth: 'account_exception_module_list'},
      },
    ]

  },
  //发票管理
  {
    path: '/bill',
    name: 'bill',
    component: project,
    meta: {
      requiresAuth: true,
      hidden: false,
      title: '发票管理',
      icon: 'el-icon-order', icon_active: 'el-icon-order-active',
      auth: 'menu_invoice_application'
    },
    children: [
      {
        path: '/bill/index',
        name: 'bill-index',
        component: () => import('./views/bill/bill.vue'),
        meta: {title: '发票列表', hidden: false, keepAlive: false, auth: 'can_invoice_application_list'},
      },
      {
        path: '/bill/apply',
        name: 'apply-invoice',
        component: () => import('./views/bill/apply.vue'),
        meta: {title: '申请开票', hidden: false, keepAlive: false, auth: 'can_invoice_apply'},
      },
      {
        path: '/bill/my',
        name: 'bill-my',
        component: () => import('./views/bill/MyApply.vue'),
        meta: {title: '我的发票', hidden: false, keepAlive: false, auth: 'can_invoice_my_apply'},
      },
      {
        path: '/bill/commission',
        name: 'commission-invoice',
        component: () => import('./views/bill/commission.vue'),
        meta: {title: '佣金开票', hidden: false, keepAlive: false, auth: 'can_invoice_commission'},
      },
      {
        path: '/bill/commission/detail',//src/views/bill/components/CommissionInvoiceDetail.vue
        name: 'commission-invoice-detail',
        component: () => import('./views/bill/components/CommissionInvoiceDetail.vue'),
        meta: {title: '佣金开票详情', hidden: false, keepAlive: false, auth: 'can_invoice_commission'},
      },
    ]
  },
  {
    path: '/sysSet',
    name: 'sysSet',
    component: project,
    meta: {
      requiresAuth: true,
      hidden: false,
      title: '系统设置',
      icon: 'el-icon-set',
      icon_active: 'el-icon-set-active',
      auth: 'system_manage'
    },
    children: [
      {
        path: '/sysSet/user',
        name: 'user',
        component: () => import('./views/sysSetting/user.vue'),
        meta: {title: '用户管理', hidden: false, keepAlive: false, auth: 'user_manage'}
      },
      {
        path: '/sysSet/organization',
        name: 'organization',
        component: () => import('./views/sysSetting/organization.vue'),
        meta: {title: '组织架构', hidden: false, keepAlive: false, auth: 'organization_manage'}
      },
      {
        path: '/sysSet/role',
        name: 'role',
        component: () => import('./views/sysSetting/role.vue'),
        meta: {title: '角色管理', hidden: false, keepAlive: false, auth: 'role_manage'}
      },
      {
        path: '/sysSet/basicSetting',
        name: 'basicSetting',
        component: () => import('./views/sysSetting/basicSetting.vue'),
        meta: {title: '基础配置', hidden: false, keepAlive: false, auth: 'setting_manage'}
      },
      {
        path: '/sysSet/dingtalk',
        name: 'dingtalk',
        component: () => import('./views/sysSetting/dingtalk'),
        meta: {title: '钉钉配置', hidden: false, keepAlive: false, auth: 'dingtalk_setting'}
      },
      {
        path: '/sysSet/feishu',
        name: 'feishu',
        component: () => import('./views/sysSetting/feishu.vue'),
        meta: {title: '飞书配置', hidden: false, keepAlive: false, auth: 'feishu_manage'}
      },
      {
        path: '/sysSet/feishuBitable',
        name: 'feishuBitable',
        component: () => import('./views/sysSetting/feishuBitable.vue'),
        meta: {title: '飞书多维表格', hidden: false, keepAlive: false, auth: 'feishu_bit_manage'}
      },
      {
        path: '/sysSet/dept',
        name: 'dept',
        component: () => import('./views/sysSetting/dept'),
        meta: {title: '钉钉部门', hidden: false, keepAlive: false, auth: 'dingtalk_dept'}
      },
      {
        path: '/sysSet/bridgeLog',
        name: 'bridgeLog',
        component: () => import('./views/sysSetting/bridgeLog.vue'),
        meta: {title: '桥接请求日志', hidden: false, keepAlive: false, auth: 'bridge_log_manage'}
      },
      {
        path: '/sysSet/dingtalkUser',
        name: 'dingtalkUser',
        component: () => import('./views/sysSetting/dingtalkUser'),
        meta: {title: '钉钉用户', hidden: false, keepAlive: false, auth: 'dingtalk_dept'}
      },
      {
        path: '/sysSet/whitelist',
        name: 'whiteList',
        component: () => import('./views/sysSetting/whiteList'),
        meta: {title: '白名单', hidden: false, keepAlive: false, auth: 'dingtalk_dept'}
      },
      {
        path: '/sysSet/resetPassword',
        name: 'resetPassword',
        component: () => import('./views/sysSetting/resetPassword.vue'),
        meta: {title: '重置密码', hidden: true, keepAlive: false, auth: 'normal'}
      }
    ]
  },
  {
    path: '/personal/updateInfo',
    name: 'updateInfo',
    component: () => import('./views/personal/updateInfo'),
    meta: {title: '基本资料', hidden: true, auth: 'normal'}
  },
  // {
  //     path: '/personal/accounts',
  //     name: 'MyAccounts',
  //     component: () => import('./views/personal/MyAccounts'),
  //     meta: {title: '我的账号', hidden: true, auth: 'normal'}
  // },
  {
    path: '/personal/updatePassword',
    name: 'updatePassword',
    component: () => import('./views/personal/updatePassword'),
    meta: {title: '修改密码', hidden: true, auth: 'normal'}
  },
  {
    path: '/noPermisson',
    name: 'noPermisson',
    component: () => import('./views/noPermisson/index'),
    meta: {title: '无权限', hidden: true, auth: 'normal'}
  }
]

// 实例化
const router = new Router({
  base: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URL : '/',
  scrollBehavior: () => ({y: 0}),
  mode: 'history',
  routes,
})

router.beforeEach((to, from, next) => {
  //判断是否登录
  ifLogin(to, next, from)
  if (from.path === '/login' && to.path === '/login') {
    //如果重定向还是login页面，则跳转/home
    next(`/home`)
  }

  //判断已经加载权限
  ifPermissions()
    .then(() => {
      // 加载完毕权限后，加载默认页面
      if (localStorage.getItem('token'))
        defaultToPage(to, from, next)
    })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.log('err', err)
      // next({ path: '/' })
    })
})

/**
 * @description 处理左侧菜单的选中
 * @author YM
 * @date 2019-01-10
 * @param {*} to 当前路由
 * @param {*} next 回调函数
 */
let ifLogin = (to, next) => {
  // let userInfo = JSON.parse(localStorage.getItem('user_info'))
  let token = localStorage.getItem('token')
  // // 判断是否是登录页
  // let idx = to.path.indexOf('login') !== -1
  // // 没有userInfo 且 不是login 页 => 登录页
  // if (!token && !idx) {
  //     // alert(to.path)
  //     next(`/login?redirect=${to.path}`)
  // }
  // // 有userinfo 且 是login 页 => 首页
  // if (idx && token) {
  //     next('/')
  // }

  //页面是否需要授权：即登录状态
  let pageNeedAuth = to.matched.some(record => record.meta.requiresAuth)

  if (pageNeedAuth) {
    // 需要登录的页面
    if (!token) {
      // 未登录，去登录注册页，登录后返回原来页面
      next(`/login?redirect=${to.fullPath}`)
    } else {
      // 已登录
      handleMenu(to)
      next();
    }
  } else {
    // 不需要登录的页面
    if (token && (to.matched.some(record => record.meta.loginBack))) {
      // 已登录，去登录注册页不允许访问，直接返回首页
      next('/');
    } else {
      handleMenu(to)
      next();
    }
  }
}

/**
 * 判断权限是否加载
 * @returns {Promise<void>}
 */
let ifPermissions = async () => {
  let token = localStorage.getItem('token')
  if (token) {
    //判断权限是否已经获取，若未获取，则加载权限
    if (store.getters.userPermissions && store.getters.userPermissions.length === 0) {
      let permissions = await getPermissions().then((res) => {
        return res.model;
      })
      await store.commit('handleUserPermissions', permissions)
    }
    // else{
    //     console.log('已加载权限')
    // }
  }
}
//登录后默认调整的页面，在权限加载之后执行
let defaultToPage = (to, from, next) => {
  let fromPath = from.path
  let toPath = to.path
  if (to.path === '/' || to.path === '/homeOld') {
    // console.log('首页、home')
    let userPermissions = store.getters.userPermissions
    if (userPermissions.indexOf('show_summary_sale') > -1 || userPermissions.indexOf('show_summary_sale') > -1 || userPermissions.indexOf('show_summary_executor') > -1) {
      toPath = '/homeOld'
    } else if (userPermissions.indexOf('manage_menu_adv_order') !== -1) {
      toPath = '/ad'
    } else {
      if (userPermissions.length === 0) {
        toPath = '/noPermisson'
      } else {
        toPath = '/'
      }
    }
  }

  if (toPath !== to.path && fromPath !== toPath) {
    next(toPath)
  }
}
//路由切换前记录打开菜单的url
let handleMenu = (to) => {
  store.commit('handleRoutePath', {path: to.path, title: to.meta ? to.meta.title : ''})
}


export default router
